import PropTypes from "prop-types";
import React from "react";
import { useTheme } from "@material-ui/core/styles";
import { Grid, Switch, FormGroup, FormControlLabel, Collapse } from "@material-ui/core";

const CollapsibleSectionToggle = ({ label, checked, onToggle, disableToggle, children }) => {
  const theme = useTheme();
  return (
    <>
      <Grid style={{ padding: theme.spacing(3, 0, 0, 2) }}>
        <FormGroup>
          <FormControlLabel
            label={label}
            control={<Switch checked={checked} onChange={onToggle} disabled={disableToggle} />}
          />
        </FormGroup>
      </Grid>
      <Grid item xs={12}>
        <Collapse in={checked} style={{ width: "100%" }}>
          {children}
        </Collapse>
      </Grid>
    </>
  );
};

CollapsibleSectionToggle.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  children: PropTypes.object,
  disableToggle: PropTypes.bool,
};

CollapsibleSectionToggle.defaultProps = {
  disableToggle: false,
  children: undefined,
};

export default CollapsibleSectionToggle;
